import React from 'react';
import { VolumeX } from 'lucide-react';
import { cn } from '@/lib/utils';

type PlayerSize = 'mobile' | 'desktop' | 'fullwidth';

interface AutoplayPreviewMiniProps {
  colors: {
    background: string;
    text: string;
    icon: string;
  };
  textTop?: string;
  textBottom?: string;
  className?: string;
  playerWidth?: number;
  size?: PlayerSize;
}

// Auto-scale baseado no tamanho do player
const getScaleClass = (playerWidth?: number, size?: PlayerSize): string => {
  // Se size foi passado explicitamente, usar ele
  if (size) {
    switch (size) {
      case 'mobile': return 'scale-[0.75]';
      case 'desktop': return 'scale-[0.90]';
      case 'fullwidth': return 'scale-100';
    }
  }
  
  // Senão, calcular pelo playerWidth
  if (!playerWidth) return 'scale-[0.85]';
  
  if (playerWidth < 480) return 'scale-[0.75]'; // Mobile
  if (playerWidth < 960) return 'scale-[0.90]'; // Desktop
  return 'scale-100'; // Full Width / VSL
};

export const AutoplayPreviewMini: React.FC<AutoplayPreviewMiniProps> = ({
  colors,
  textTop = 'Seu vídeo já começou',
  textBottom = 'Toque para ativar o som',
  className,
  playerWidth,
  size
}) => {
  const scaleClass = getScaleClass(playerWidth, size);

  return (
    <div 
      className={cn(
        "rounded-lg px-4 py-3 flex items-center gap-3",
        "shadow-lg transition-transform duration-200 origin-center",
        scaleClass,
        className
      )}
      style={{ 
        backgroundColor: colors.background,
        color: colors.text 
      }}
    >
      <div 
        className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center"
        style={{ backgroundColor: `${colors.icon}20` }}
      >
        <VolumeX 
          className="h-5 w-5" 
          style={{ color: colors.icon }} 
        />
      </div>
      <div className="flex flex-col gap-0.5 min-w-0">
        <span 
          className="text-sm font-medium truncate"
          style={{ color: colors.text }}
        >
          {textTop}
        </span>
        <span 
          className="text-xs opacity-70 truncate"
          style={{ color: colors.text }}
        >
          {textBottom}
        </span>
      </div>
    </div>
  );
};
